import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { TEAM_GAMES_DEFAULT_COLUMNS } from '@/components/tables/GameAggregatesTable.constants';

const teamGameDataDefaultColumnsAtom = atom(async () => [...TEAM_GAMES_DEFAULT_COLUMNS]);
export const unwrappedTeamGameDataDefaultColumnsAtom = unwrap(teamGameDataDefaultColumnsAtom, prev => prev || []);
